import React from 'react'
import { scrollToElement, scrollTop } from '../../common/lib/scroll'

class ScrollView extends React.Component {

  state = {
    lastId: null,
    lastPathName: null,
  }

  componentDidMount() {
    this.scroll()
  }

  componentDidUpdate() {
    // this.scroll()
  }

  scroll() {
    // console.log('ScrollView component scroll ')
    const { id, location } = this.props

    if (!id) {
     // console.log('ScrollView scrollIntoView - scroll to body')
      // const body = document.querySelector('body')
      // console.log('body', body)
      // return body.scrollIntoView({ behavior: 'instant' })
      // return scrollTop(1)
      return window.scrollTo(0, 0)
    }
    let hash = id
    if (hash[0] !== '#') hash = `#${hash}`
    // console.log('ScrollView - scroll to element, ', hash)
    // const element = document.querySelector(hash)
    // console.log('element', element)
    // element.scrollIntoView({ behavior: 'instant' })
    scrollToElement(id, 1)
  }

  /*
  scroll() {
    const { id, location } = this.props

    const body = document.querySelector('body')
    if (!id) {
      body.scrollTop = 0
      return
    }

    const element = document.querySelector(id)

    if (element) {
      element.scrollIntoView()
    }
  }  */

  render() {
    return (<div>{this.props.children}</div>)
  }
}

export default ScrollView



// WEBPACK FOOTER //
// ./src/browser/components/ScrollView.js